import Indicador from "..";
import PisoEditFields from "./components/PisoEditFields";
import { PisoParamFields } from "./components/PisoParamFields";
import pisoReport from "./reports";
import pisoReportSummary from "./reports/summary";

export default class Piso extends Indicador {
    static get fullName() {
        return "Pisoteio";
    }

    static get abbrev() {
        return "Piso.";
    }

    static get field() {
        return "piso";
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraEES: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            frente: "frente",

            turno: "turno",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    ruasAvaliadas: "ruasAvaliadas",
                    ruasComPisoteio: "ruasComPisoteio",
                    pisoteio: "pisoteio",
                    descricao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostraEES: "observacao",

            itensColetaEES: "images",
        };
    }

    static get legacyParamMap() {
        return {
            metaPercentualRuasPisoteioManual: "manual.meta",

            metaPercentualRuasPisoteioMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <PisoParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <PisoEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return pisoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return pisoReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumPisoteio = 0;

        for (const coleta of apontamento.coletas) {
            // 'ruasAvaliadas' deve ser um número != 0.
            if (coleta.ruasComPisoteio && f(coleta.ruasAvaliadas)) {
                coleta.pisoteio = (100 * f(coleta.ruasComPisoteio)) / f(coleta.ruasAvaliadas);
                sumPisoteio += coleta.pisoteio;

                coleta.pisoteio = f(coleta.pisoteio).toFixed(2);
            } else {
                coleta.pisoteio = "0.00";
            }
            coleta.acima = f(coleta.pisoteio) > f(params.meta) ? 1 : 0
            coleta.abaixo = 0
        }

        return (sumPisoteio / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        let minOtimo = parseFloat(meta)
        let minBom = parseFloat(meta)
        let minRegular = parseFloat(meta) + 10

        if (parseFloat(conformidade) <= minOtimo) {
            return "Ótimo";
        } else if (parseFloat(conformidade) <= minBom) {
            return "Bom";
        } else if (parseFloat(conformidade) <= minRegular) {
            return "Regular";
        } else {
            return "Ruim";
        }

        // return this.calcConformidadeStatusInverte(conformidade, meta, 110, 100, 90);
    }
    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 50, getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 25 },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Turno", field: "turno", width: 'auto' },//
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },

            {
                title: "Linhas Avaliadas", width: 'auto', getValue: (a) => {
                    let sum = a.coletas?.reduce((total, c) => total += parseInt(c.ruasAvaliadas), 0)
                    return sum
                }
            },
            {
                title: "Linhas Pisoteadas", width: 'auto', getValue: (a) => {
                    let sum = a.coletas?.reduce((total, c) => total += parseInt(c.ruasComPisoteio), 0)
                    return sum
                }
            },

            {
                title: "Pisoteio (%)", field: "conformidade", width: 'auto', getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },

        ]
    }

    static getResultStr(apontamento) {
        let linhasAvaliadas = apontamento.coletas?.reduce((total, c) => total += parseInt(c.ruasAvaliadas), 0)
        let linhasPisoteadas = apontamento.coletas?.reduce((total, c) => total += parseInt(c.ruasComPisoteio), 0)

        return "Linhas Avaliadas: " + linhasAvaliadas +
            " e Linhas Pisoteadas: " + linhasPisoteadas
    }
}
